function SmsModal($timeout, onsiteService, twilioService) {
    return {
        restrict: 'E',
        scope: {},
		template: require('./sms-modal.html'),

        link: function (scope) {
            scope.message = "";
            scope.sending = false;
            scope.visit = null;

            function initModal(event, args){
                scope.visit = args;
                $("#sms-modal").modal('show');
                $("#sms-modal").on('shown.bs.modal', function() {
                    $("#smsText").trigger('focus');
                })
            }

            scope.submitOnEnter = function(event){
                if(event.keyCode === 13 && event.ctrlKey && scope.isTextMessageValid()) {
                    scope.sendSmsText();
                }
            };

            scope.isTextMessageValid = function () {
                return scope.message.trim().length > 0 && scope.message.trim().length < 181;
            };

            scope.sendSmsText = function () {
                scope.sending = true;
                twilioService.sendSMSText({
                    logId: scope.visit.logId,
                    noteId: scope.visit.noteId,
                    contactName: scope.visit.userName,
                    toNumber: scope.visit.phoneNumber,
                    message: scope.message,
                    onsiteComment: true
                }).then(function (message) {
                    //scope.$emit('refresh-requested');
                    $timeout(function () {
                        scope.message = "";
                        scope.sending = false;
                        scope.visit = null;
                        $("#sms-modal").modal('hide');
                    }, 1000);
                });
            };

            scope.cancelSmsSend = function () {
                scope.visit = null;
                $("#sms-modal").modal('hide');
            };

            scope.$on('show-sms-modal', initModal);
        }
    }
}

angular.module('onsite').directive('smsModal', ['$timeout', 'onsiteService', 'twilioService', SmsModal]);
